/**
 * Z regionalStructure bezpečně vytáhne název kraje.
 * - vezme poslední "regional.region" před státem
 * - filtruje jen položky, které vypadají jako kraj (končí na "kraj" nebo "Hlavní město Praha")
 */
function getKrajNameFromRegionalStructure(regionalStructure) {
    if (!Array.isArray(regionalStructure)) return "";

    const clean = (name) => {
        if (!name) return "";
        let n = String(name).replace(/\u00A0/g, " ").trim();
        
        if (/^okres\s+/i.test(n) && /hlavn[ií]\s+m[eě]sto\s+praha/i.test(n)) {
            return "Hlavní město Praha";
        }

        // obecný cleanup (neškodí): "okres X" -> "X"
        n = n.replace(/^okres\s+/i, "").trim();

        return n;
    };

    const regions = regionalStructure
        .filter(x => x && x.type === "regional.region" && typeof x.name === "string")
        .map(x => clean(x.name))
        .filter(Boolean);

    // projdeme odzadu – nejvyšší úroveň bývá na konci
    for (let i = regions.length - 1; i >= 0; i--) {
        const n = regions[i];
        if (/kraj$/i.test(n) || /^hlavn[ií]\s+m[eě]sto\s+praha$/i.test(n)) {
            return n;
        }
    }

    // fallback
    return regions.length ? regions[regions.length - 1] : "";
}

/**
 * Nastaví hodnotu <select> podle viditelného textu <option>.
 * (normalizace: trim, lowercase, sjednocení mezer, odstranění diakritiky)
 */
function setSelectByOptionText(selectSelector, wantedText) {
    const selectEl = document.querySelector(selectSelector);
    if (!selectEl || !wantedText) return false;

    const normalize = (s) =>
        String(s)
            .replace(/\u00A0/g, " ")
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, " ");

    const target = normalize(wantedText);

    const opt = Array.from(selectEl.options).find(o => normalize(o.textContent) === target);
    if (!opt) return false;

    selectEl.value = opt.value;
    selectEl.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
}

/**
 * Global function for registering Seznam's "naseptavac" to input element.
 * @param {Array.<string>} e - Main input element (with searching address)
 * @param {string} u - Address input element which should be updated by SMap suggest
 * @param {string} o - City input element ..
 * @param {string} p - Postal code input element ..
 * @param {string} d - District select element selector (kraje)
 */
function registerNaseptavac(e, u, o, p, d) {
    e.forEach((inpt) => {
        $(inpt).autocomplete({
            delay: 500,
            classes: {
                "ui-autocomplete": "address-suggest"
            },
            source: (_val, response) => {
                const query = e.reduce((acc, el) => {
                    const v = document.querySelector(el)?.value;
                    return acc + (v ? v + "," : "");
                }, "");

                $.nette.ajax({
                    type: "POST",
                    url: "?do=suggestAddress",
                    off: ['modals'],
                    data: { query },
                    success: (data) => {
                        if (data.items && data.items.length > 0) {
                            const result = data.items.map((address) => {
                                console.log(address);

                                const kraj = getKrajNameFromRegionalStructure(address.regionalStructure);

                                return {
                                    value: `${address.regionalStructure?.[1]?.name ?? ""} ${address.regionalStructure?.[0]?.name ?? ""}`.trim(),
                                    label: `${address.regionalStructure?.[3]?.name ?? ""}${address.regionalStructure?.[2]?.name ? ` - ${address.regionalStructure[2].name}` : ""}`,
                                    postal: `${address.zip ?? ""}`,
                                    district: kraj, //  už správný název kraje
                                };
                            });

                            response(result);
                            return;
                        }

                        response([]);
                    }
                });
            },
            select: function (event, ui) {
                document.querySelector(o).value = ui.item.label || "";
                document.querySelector(u).value = ui.item.value || "";
                document.querySelector(p).value = ui.item.postal || "";

                // vyber kraj podle názvu kraje (ne podle indexu)
                setSelectByOptionText(d, ui.item.district);

                return false;
            }
        }).autocomplete("instance")._renderItem = function (ul, item) {
            return $(`<li>`)
                .append(`<div><span class="font-weight-bold">${item.value}</span><br>${item.postal} ${item.label}<br><small>${item.district || ""}</small></div>`)
                .appendTo(ul);
        };
    });
}